/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/11/15
 * Time: 3:13 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-web-agent-templates/widgetListAnchorView.tmpl");

    var Bubble = require("ui/bubble/Bubble");
    var Button = require("ui/button/Button");

    var BaseAnchorView = require("personalization-views/BaseAnchorView");
    var WidgetListView = require("personalization-web-agent-views/widget-views/widget-list/WidgetListView");
    var PositionsUtility = require("personalization-utils/positionsUtility");
    var KpContent = require("ui.components/kpContent/kpContent");

    var WidgetListAnchorView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetListAnchorView = BaseAnchorView.extend({
            className: "iFrame-integration-anchor anchor",
            template: Template,
            ui:{
                widgetListContainer: ".widget-list",
                widgetListBubble: ".widget-list-bubble",
                widgetListBubbleLink: ".widget-list-bubble-link",
                knowledgePack: ".kp"
            },
            uiComponents:{
                widgetsListView: {
                    type: WidgetListView,
                    options: {
                        el: "view.ui.widgetListContainer",
                        collection: "view.widgetsCollection",
                        vent: "view.vent"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.webAgent.ACD.title.learnMore"),
                        kpID: "webagent-integration"
                    }
                }
            },


            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing WidgetListAnchorView", "WidgetListAnchorView:initialize");
                this.vent = options.vent;
                this.widgetsCollection = options.widgetsCollection;

                BaseAnchorView.prototype.initialize.call(this, options);
                this.anchorSelector = options.anchorSelector;
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetListAnchorView", "WidgetListAnchorView:onRender");
                var offset = PositionsUtility.getOffset(this.anchorSelector, PositionsUtility.POSITION_X.LEFT, PositionsUtility.POSITION_Y.TOP);
                if (offset) {
                    // there is an offset with the top (because of the user bar) and we need to re-set it
                    offset.top = (parseInt(offset.top, 10) - 22) + "px";
                    this.$el.css(offset);
                }
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetListAnchorView", "WidgetListAnchorView:onClose");
            }
        });
    });
    return WidgetListAnchorView;
});

